import React, { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import DataTable from "../../../Common/Components/DataTable";
import {
  GetData,
  DeleteData,
  getCity,
  getProvinces,
  EditData,
} from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import CustomModal from "../../../Common/Components/Modal/CustomModal";
function List() {
  const initialState = {
    loading: true,
    data: {
      data: null,
      current_page: null,
      city: 0,
      province: 0,
    },
    modal: false,
  };
  const [state, setstate] = useState(initialState);
  const [regions, setRegions] = useState();

  useEffect(() => {
    Handler();
  }, []);
  useEffect(() => {
    getProvines();
  }, []);

  const getProvines = () => {
    setstate({ ...state, loading: true });
    getProvinces().then(res => {
      setstate({ ...state, provinces: res, loading: false });
    });
  };

  const Handler = (pageNumber = 1, id, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, id, limit, index).then(result => {
      setRegions({
        ...state,
        city: id,
        data: result,
      });
      setstate({ ...state, loading: false });
    });
  };

  const HandlerDelete = data => {
    setstate({ ...state, loading: true });
    DeleteData(data).then(() => {
      GetData(state.data.current_page, state.city).then(result => {
        setstate({
          ...state,
          loading: false,
          data: result,
        });
      });
    });
  };
  const HandlerEdit = data => {
    setstate({ ...state, loading: true });
    EditData({
      ...data,
      region_id:
        regions.data &&
        regions.data.data &&
        regions.data.data
          .filter(user => user.id == state.modal)
          .filter(Boolean)[0].id,
    }).then(() => {
      GetData().then(result => {
        setstate({
          loading: false,
          data: result,
        });
      });
    });
  };
  // region/update

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مناطق</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        filter={true}
        heads={[
          {
            title: "نام منطقه",
            key: "name",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="منطقه ای  ثبت نشده"
        list={regions && regions.data && regions.data.data}
        data={regions && regions.data}
        function={Handler}
        currentPage={regions && regions.data.current_page}
        header=" لیست مناطق"
        textbtn="ایجاد منطقه"
        linkbtn="/Admin/Region/Create"
        messageToast="برای مشاهده مناطق ابتدا استان و شهر را انتخاب کنید"
        links={[
          {
            size: "col-md-5",
            typeLink: "div",
            html: (
              <Fragment>
                <select
                  onChange={e => {
                    getCity({ province_id: e.target.value }).then(res => {
                      setstate({
                        ...state,
                        citeis: res,
                        province: e.target.value,
                      });
                    });
                  }}
                  className="form-control col-12"
                >
                  <option value="0">انتخاب استان</option>
                  {state.provinces &&
                    state.provinces.map((province, key) => {
                      return (
                        <option
                          key={key}
                          selected={province.id == state.province}
                          value={province.id}
                        >
                          {province.name}
                        </option>
                      );
                    })}
                </select>
              </Fragment>
            ),
          },
          {
            size: "col-md-5",
            typeLink: "div",
            html: (
              <Fragment>
                <label htmlFor="">انتخاب شهر</label>
                <select
                  onChange={e => {
                    Handler(1, e.target.value);
                  }}
                  className="form-control col-12"
                >
                  <option value="0">انتخاب شهر</option>
                  {state.citeis &&
                    state.citeis.map((city, key) => {
                      return (
                        <option
                          key={key}
                          selected={city.id == state.city}
                          value={city.id}
                        >
                          {city.name}
                        </option>
                      );
                    })}
                </select>
              </Fragment>
            ),
          },
          {
            function: selected => {
              HandlerDelete({ region_id: selected });
            },
            color: "danger",
            size: "col-md-2",
            html: "حذف",
            multi: true,
            type: "delete",
          },
          {
            function: selected => {
              setstate({ ...state, modal: selected[0] });
            },
            color: "info",
            type: "key",
            size: "col-md-2",
            html: "ویرایش",
            type: "edit",
            main: true,
          },
        ]}
      />
      <CustomModal
        show={state.modal}
        handleClose={() => {
          setstate({ ...state, modal: false });
        }}
        header={"ویرایش منطقه"}
      >
        <CommonFrom
          loading={state.loading}
          form={[
            {
              label: "نام منطقه",
              name: "name",
            },
          ]}
          btnName={"ثبت "}
          value={
            regions &&
            regions.data &&
            regions.data.data &&
            regions.data.data
              .filter(user => user.id == state.modal)
              .filter(Boolean)[0]
          }
          edit={true}
          submit={HandlerEdit}
        />
      </CustomModal>
    </Fragment>
  );
}

export default List;
